import axios from "axios";
import EncrDecrService from "../services/EncrDecrService.Service";
//import { GetTokenCookie } from "../shared/SharedUtility";
import GlobalService from "../services/GlobalService";

axios.defaults.withCredentials = true;
/*****************************/
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  // [::1] is the IPv6 localhost address.
  window.location.hostname === '[::1]' ||
  // 127.0.0.0/8 are considered localhost for IPv4.
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);
const http = axios.create({
  baseURL: isLocalhost ? "http://localhost:4004/api-gateway" : window.location.origin + "/api-gateway",
  //baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "timeout": 15
  },
});
export const httpBase = axios.create({
  //baseURL: process.env.REACT_APP_REDIRECT_URL,
  baseURL: isLocalhost ? "http://localhost:4004" : window.location.origin,
  headers: {
    "Access-Control-Allow-Origin": "*",
  },
});
/*****************************/


http.interceptors.request.use(
  (req) => {
    var { config } = window.global;
    // Add configurations here
    if (config.intercept) {
      const token = GlobalService.getOAuthToken()?.accessToken; //GetTokenCookie();
      if (token && token.length) {
        req.headers["Authorization"] = "Bearer " + token;
        if(!req.headers["Content-Type"]){
          req.headers["Content-Type"] = config.EncrDecr ? "text/plain" : "application/json";
        }
        
      }

      if (config.EncrDecr && req.url.indexOf("tokenGen") < 0) {
        req.data = EncrDecrService.set(req.data);
      }
    }

    return req;
  },
  (err) => {
    return Promise.reject(err);
  }
);

http.interceptors.response.use(
  (res) => {
    var { config } = window.global;
    // Add configurations here
    if (config.EncrDecr && res.request.responseURL.indexOf("tokenGen") < 0 && res.data?.length){
      res.data = JSON.parse(EncrDecrService.get(res.data));
    }
    return res;
  },
  (err) => {
    return Promise.reject(err);
  }
);
export default http;
